export function notEmpty(value) {
    return value !== null && value !== undefined;
}
/* istanbul ignore next */
export function assertUnreachable(_x, msg) {
    throw new Error(msg);
}
/**
 * Python's equivalent of range() function
 * @param start An integer number specifying at which position to start.
 * @param end An integer number specifying at which position to stop (not included).
 * @returns A sequence of numbers, starting from {start}, and increments by 1, and stops before {end}.
 */
export function range(start, end) {
    return [...Array(end - start).keys()].map((v) => start + v);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXRlcmF0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi91dGlscy9pdGVyYXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxVQUFVLFFBQVEsQ0FDdEIsS0FBZ0M7SUFFaEMsT0FBTyxLQUFLLEtBQUssSUFBSSxJQUFJLEtBQUssS0FBSyxTQUFTLENBQUE7QUFDOUMsQ0FBQztBQUVELDBCQUEwQjtBQUMxQixNQUFNLFVBQVUsaUJBQWlCLENBQUMsRUFBUyxFQUFFLEdBQVc7SUFDdEQsTUFBTSxJQUFJLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQTtBQUN0QixDQUFDO0FBRUQ7Ozs7O0dBS0c7QUFDSCxNQUFNLFVBQVUsS0FBSyxDQUFDLEtBQWEsRUFBRSxHQUFXO0lBQzlDLE9BQU8sQ0FBQyxHQUFHLEtBQUssQ0FBQyxHQUFHLEdBQUcsS0FBSyxDQUFDLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLEtBQUssR0FBRyxDQUFDLENBQUMsQ0FBQTtBQUM3RCxDQUFDIn0=